export const resourcesCategories = [
	'Nursing',
	'Health science',
	'Pharmacy',
	'Dentistry',
	'Mental health',
	'Engineering',
	'Multidisciplinary',
	'Technology',
	'Earth science',
	'Trades',
	'Fire protection',
	'Ocean education',
	'Education',
	'Business administration',
	'Filmaking',
	'Social science',
	'Art',
	'Religion',
	'Aviation',
	'Paramedic education',
	'Beauty and wellness',
	'Legal education',
	'Veterinary education',
	'Nephrology',
	'Transport',
	'Radiology',
	'Biology',
	'Jewish studies',
	'Culinary arts',
];